import { Component, ChangeDetectorRef, ElementRef, ViewChild } from '@angular/core';
import { expand, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { API } from 'src/app/core/constants';
import { AddChannelCommunityDialogComponent } from '../add-channel-community-dialog/add-channel-community-dialog.component';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { PubNubService } from 'src/app/core/services/pubnub.service';
import { AppService } from 'src/app/core/services/app.service';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ToastrService } from 'ngx-toastr';
import { WebSocketService } from 'src/app/core/services/websocket.service';
import { environment } from './../../../../../../environments/environment';


@Component({
  selector: 'app-community-sidenav',
  templateUrl: './community-sidenav.component.html',
  styleUrls: ['./community-sidenav.component.scss']
})
export class CommunitySidenavComponent {
  userInfo: any;
  channelName: string = '';
  searchQuery: string = '';
  organizationId: any;
  userInfoSubscription: any;
  performerInfoSubscr: any;
  teamsList: any[] = [];
  channelIdsList: string[] = [];
  publicTeamsList: any[] = [];
  affiliatePrivateChannelsByTeam: any[] = [];
  settingsData: any = {};
  org_info: any;
  settingsDataSubscription: Subscription;
  channelCreatedby: any;
  channels: any[] = [];
  searchChannel: string = "";
  privateChannels: any[] = [];
  publicChannels: any[] = [];
  filteredChannels: any[] = [];
  filteredPrivateChannels: any[] = [];
  filteredPublicChannels: any[] = [];
  filteredStarredChannels: any[] = [];
  filteredJoinedChannels: any[] = [];
  filteredTrendingChannels: any[] = [];
  starredChannels: any[] = [];
  joinedChannels: any[] = [];
  joinedChannelNames: any[] = [];
  trendingChannels: any[] = [];
  user_id: any;
  availableChannels: any = [];
  unreadCount: { [key: string]: number } = {};
  networkScrollbarClass = 'scrollbar-default';
  communityData: any;
  favChannelIds: any[] = [];
  accordion = {
    'My Channels': true,
    Starred: true,
    joined: true,
    trending: true,
    Channels: true,
  };
  isTeamMember =false;
  privateTeamsList: any[] = [];


  userRole: string;
  //  userRole: any = "affiliate";
  activeTab: 'private' | 'public' = 'public';
  @ViewChild('scrollElement') scrollElement!: ElementRef;
  perfomerInfoData: any;
  activeChannel: string = '';
  joinedChannelsSub!: Subscription;
  keysetReadySub!: Subscription;
  trendingChannelsData: any[] = [];
  trendingSocketSub?: Subscription;

  // Group filter - groupsList sourced from perfomerInfoData the same way event-marketplace/
  // gener-list read it (response.data.Data[0].groups), matching this component's existing
  // snapshot-read pattern for perfomerInfoData rather than adding a new reactive subscription.
  groupsList: any[] = [];
  groupsLabel = 'Group';
  selectedGroup: any = null;
  selectedGroupName = '';
  groupSearchText = '';
  groupDisplayFn = (g: any) => g?.group_name || g?.name || '';

  // Group is already implied by the URL when browsing a group-scoped page, so the Group
  // filter card is redundant and hidden - same pattern as event-marketplace's isGroupScoped.
  get isGroupScoped(): boolean {
    return !!this.commanSubscribeService.activeGroupId;
  }

  constructor(
    private router: Router,
    private matDialog: MatDialog,
    private appTVService: AppService,
    private commanSubscribeService: CommanSubscribeService,
    private pubnubService: PubNubService,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private ngxLoader: NgxUiLoaderService,
    private toaster: ToastrService,
    private commanService: CommanSubscribeService,
    private commonSubscribeService: CommanSubscribeService,
    private wsService: WebSocketService
  ) {

    this.userRole = localStorage.getItem('role')
    this.userRole = this.userRole?.replace(/\"/g, '')
    this.settingsData = this.commanSubscribeService.icWebpageSettingsData;
    this.addStyle();
    const currentUrl = this.router.url;
    const segments = currentUrl.split('/');
    this.activeChannel = segments[segments.indexOf('community') + 1];
    // this.pubnubService.joinedChannels$.subscribe(channels => {
    //   console.log("joinedChannels$", channels)
    //   this.joinedChannelNames = channels.map((channel: any) => channel.channel.id);
    //   this.cdRef.detectChanges();
    // });
    this.joinedChannelsSub=this.pubnubService.joinedChannels$.subscribe(memberships => {
      // Fires on every setMemberships() call, including silent auto-grants
      // from opening a public space - exclude those here too, same reason
      // as getJoinedChannelsAsync() below.
      this.joinedChannelNames = memberships
        .filter((m: any) => m.custom?.autoJoined !== true)
        .map((m: any) => m.channel.id);
    });
    this.appTVService.refresh$.subscribe(() => {
      this.getAllChannels();
    });

    this.pubnubService.unreadChannels$.subscribe((status) => {
      this.unreadCount = status;
      // this.getAllChannels();
      this.getAllChannelNames();
    });
  }

  async ngOnInit() {
    this.pubnubService.init();
    // getAllChannels()/getJoinedChannelsAsync() below can run before the
    // real org keyset replaces the placeholder one init() starts with,
    // silently misclassifying every joined space as not-joined for the
    // rest of the session (see getJoinedChannelsAsync()) - re-fetch once
    // the real keyset is actually in.
    this.keysetReadySub = this.pubnubService.keysetReady$.subscribe(() => {
      this.getJoinedChannelsAsync();
    });
    this.channelName = this.router.url.split("/")[1];
    if (this.channelName.includes("?")) {
      this.channelName = this.channelName.split("?")[0];
    }
    this.userInfoSubscription = this.commanSubscribeService.getUserInfo().subscribe((response) => {
      this.userInfo = response;
      this.user_id = this.userInfo?.id ? 'fan_' + this.userInfo?.id : null;
    });
    this.settingsDataSubscription = this.commanSubscribeService.getICWebpageThemeSettings().subscribe((response) => {
      this.settingsData = response;
      this.addStyle();
      this.organizationId = this.settingsData?.channelInfo?.org_id;
      this.perfomerInfoData = this.commanSubscribeService.perfomerInfoData;
      this.org_info = this.commanSubscribeService.activeGroup ? this.commanSubscribeService.activeGroup.group_logo : this.perfomerInfoData.data?.Data[0]?.org_info?.channel_logo;
      this.groupsList = this.perfomerInfoData?.data?.Data[0]?.groups || [];
      this.groupsLabel = this.perfomerInfoData?.data?.Data[0]?.network_type_label || 'Group';
      this.appTVService.refresh$.subscribe(() => {
        this.getAllChannels();
      });
      this.getAllChannels();
    });
    this.userInfo = this.commanSubscribeService.userInfo;
    this.settingsData = this.commanSubscribeService.icWebpageSettingsData;
    this.addStyle();
    this.user_id = this.userInfo?.id ? 'fan_' + this.userInfo?.id : null;
    this.organizationId = this.settingsData?.channelInfo?.org_id;
    this.perfomerInfoData = this.commanSubscribeService.perfomerInfoData;
    this.org_info = this.commanSubscribeService.activeGroup ? this.commanSubscribeService.activeGroup.group_logo : this.perfomerInfoData.data?.Data[0]?.org_info?.channel_logo;
    this.groupsList = this.perfomerInfoData?.data?.Data[0]?.groups || [];
    this.groupsLabel = this.perfomerInfoData?.data?.Data[0]?.network_type_label || 'Group';

    if (this.userInfo && this.settingsData) {
      this.getAllChannels();
    }

    const memberships = ('fan_' + this.userInfo.id)?await this.pubnubService.getMemberships('fan_' + this.userInfo.id):[];
    // Same exclusion as getJoinedChannelsAsync() below - a silently
    // auto-granted membership (from opening a public space) isn't a join.
    this.joinedChannelNames = memberships
      ?.filter((m: any) => m.custom?.autoJoined !== true)
      .map((m: any) => m.channel.id) ?? [];

    this.ngxLoader.stop();
    this.connectTrendingSocket();
  }

  // groupId here mirrors getAllChannels()'s derivation (activeGroupId || selectedGroup) so
  // trending stays scoped the same way the rest of the sidenav's data is. wsService.getMessages()
  // returns an Observable bound to whichever socket was active at subscribe time - connect()
  // alone wouldn't redirect an already-active subscription, so the old one is unsubscribed and a
  // fresh one taken out against the new socket on every call (initial connect and group change).
  private connectTrendingSocket() {
    this.trendingSocketSub?.unsubscribe();
    const baseUrl = environment.API_URL_TV_BASE;
    const wsBaseUrl = baseUrl.replace(/^http/, 'ws');
    const groupId = this.commanSubscribeService.activeGroupId || this.selectedGroup;
    const wsUrl = groupId
      ? `${wsBaseUrl}ai-ingestion-service/ws/trending/${this.organizationId}?network_group_id=${groupId}`
      : `${wsBaseUrl}ai-ingestion-service/ws/trending/${this.organizationId}`;
    this.wsService.connect(wsUrl);
    this.trendingSocketSub = this.wsService.getMessages().subscribe({
      next: (msg) => {
        this.trendingChannelsData = msg.trending_spaces;
        this.cdRef.detectChanges();
      },
      error: (err) => console.error(err),
      complete: () => console.log('Connection closed')
    });
  }
  ngAfterViewInit() {
    const scrollColor = this.settingsData?.form_bg_secondary_color;
    const scrollBackcolor = this.settingsData?.form_bg_primary_color;
    if (scrollColor || scrollBackcolor) {
      this.scrollElement?.nativeElement.style.setProperty('--scroll-color', scrollColor);
      this.scrollElement?.nativeElement.style.setProperty('--scroll-backcolor', scrollBackcolor);
    }
  }

  async getAllChannels() {
    const url = API.GET_ORG_COMMUNITY_CHANNELS;

    try {
      if (this.organizationId) {
        // Manual Group filter selection only applies when not already URL-scoped - the Group
        // filter card is hidden via isGroupScoped once activeGroupId is set, so activeGroupId
        // always wins when both are present.
        const groupId = this.commanSubscribeService.activeGroupId || this.selectedGroup;
        let apiUrl;
        if (groupId) {
          apiUrl = `${url}/${this.organizationId}?networkGroupId=${groupId}`;
        } else {
          // Network level — community-service has no access to TB_PERFORMER_INFO/
          // show_content_to_network itself, so resolve the allow-list here (groupsList
          // already carries it from getPerfomerInfo) and pass it along.
          const visibleGroupIds = (this.groupsList || [])
            .filter(g => g.show_content_to_network == 1)
            .map(g => g.id);
          apiUrl = visibleGroupIds.length > 0
            ? `${url}/${this.organizationId}?visibleGroupIds=${visibleGroupIds.join(',')}`
            : `${url}/${this.organizationId}`;
        }
        const result = await this.appTVService.getBaseRequest(apiUrl, `fan_${this.userInfo.id}`).toPromise();

      if (result?.teams?.length) {
        this.teamsList = result.teams.sort((a, b) => (a.teamId > b.teamId ? 1 : -1));
        const currentUserId = parseInt(this.userInfo.id);
        this.privateTeamsList = this.teamsList.map(team => ({ teamId: team.teamId, teamName: team.teamName, channels: (team.channels || []).filter(channel => channel.channelVisibility === 'private' && channel.users?.some(user => user.userId === currentUserId)).sort((a, b) => a.channelName.localeCompare(b.channelName)) }));
        this.isTeamMember = this.privateTeamsList.some(team => team.channels.length > 0);
        const allChannels = this.teamsList.map((team) => team.channels || []).flat();
        this.availableChannels = [...allChannels];

          if (this.isTeamMember) {
            this.privateChannels = this.teamsList.map(team => ({
              teamId: team.teamId,
              teamName: team.teamName,
              channels: (team.channels || []).filter((ch) => (ch.channelVisibility || '').toLowerCase() === 'private')
            }));
            this.publicChannels = allChannels.filter((ch) =>
              (ch.channelVisibility || '').toLowerCase() === 'public' &&
              (ch.createdBy?.split('_')[1] === this.userInfo.id)
            );
            this.communityData = this.activeTab === 'private' ? this.privateChannels : this.publicChannels;
          } else {
            this.channels = allChannels.filter((ch) =>
              (ch.channelVisibility || '').toLowerCase() === 'public' &&
              (ch.createdBy?.split('_')[1] === this.userInfo.id)
            );
            this.communityData = this.channels;
          }
          // joinedChannels/trendingChannels both key off joinedChannelNames,
          // which getJoinedChannelsAsync() below is what actually fetches -
          // computing them here first used a stale (empty, on first load)
          // joinedChannelNames, so trending absorbed every joined channel
          // instead of excluding them. Both are computed together inside
          // getJoinedChannelsAsync() once the real membership list is in.
          // Wait for both to finish
          await this.getFavChannelsAsync();
          await this.getJoinedChannelsAsync();

          this.connectChannels();
          this.onTypeSearch(this.searchChannel, true);
        } else {
          this.channels = [];
          this.availableChannels = [];
        }
      }
    } catch (error) {
      console.error("Error fetching channels:", error);
    }
  }

  selectGroup(group: any) {
    this.selectedGroup = group ? group.id : null;
    this.selectedGroupName = group ? (group.group_name || group.name) : '';
    this.groupSearchText = '';
    this.getAllChannels();
    this.connectTrendingSocket();
  }

  getFavChannelsAsync(): Promise<void> {
    const url = API.GET_ALL_FAVOURITE_CHANNELS;
    const data = {
      dataStatus: "A",
      userId: 'fan_' + this.userInfo?.id,
      pageNumber: 0,
      limit: 0
    };

    return new Promise((resolve, reject) => {
      this.appTVService.postBaseRequest(url, data).subscribe(
        (result) => {
          const favData = result?.data || [];
          this.favChannelIds = favData.map(item => item.channelId);
          this.starredChannels = this.availableChannels.filter(channel =>
            this.favChannelIds.includes(channel.channelId) &&
            (channel.channelVisibility || '').toLowerCase() === 'public' &&
            (channel.createdBy?.split('_')[1] !== this.userInfo.id)
          );
          this.filteredStarredChannels = [...this.starredChannels];
          resolve();
        },
        (error) => {
          console.error("Error fetching starred channels:", error);
          this.starredChannels = [];
          resolve(); // Still resolve so app doesn't hang
        }
      );
    });
  }

  getJoinedChannelsAsync(): Promise<void> {
    return new Promise((resolve) => {
      this.pubnubService.getMemberships(this.user_id).then((memberships: any[]) => {
        // A membership existing at all isn't the same thing as this fan
        // having joined - opening a public space auto-grants one silently
        // (custom.autoJoined: true, see pubnub.service.ts's setMemberships())
        // so they can read/post immediately. Only count real, explicit
        // joins here, so a space the fan merely opened still shows under
        // Trending instead of jumping to Joined on its own.
        this.joinedChannelNames = memberships
          ?.filter((m: any) => m.custom?.autoJoined !== true)
          .map((m: any) => m.channel.id) ?? [];
        this.joinedChannels = this.availableChannels.filter((ch) =>
          (ch.channelVisibility || '').toLowerCase() === 'public' &&
          this.joinedChannelNames.includes(ch.channelUrl) &&
          (ch.createdBy?.split('_')[1] !== this.userInfo.id)
        );
        this.filteredJoinedChannels = [...this.joinedChannels];
        // Computed here (not in getAllChannels()) so it always uses the
        // joinedChannelNames that was JUST fetched, not whatever was set
        // before this call - see the call sites for why that ordering matters.
        this.trendingChannels = this.availableChannels.filter((ch) =>
          (ch.channelVisibility || '').toLowerCase() === 'public' &&
          !this.joinedChannelNames.includes(ch.channelUrl) &&
          (ch.createdBy?.split('_')[1] !== this.userInfo.id) &&
          ch.dataStatus !== 'P'
        );
        resolve();
      }).catch((err) => {
        console.error("Error fetching joined channels:", err);
        resolve();
      });
    });
  }

  getVisibleSections(): string[] {
    if (this.activeTab === 'private') {
      return ['Channels'];
    }
    return ['My Spaces', 'Starred', 'joined', 'trending'];
  }
  // Trending member counts, reused while the fan types in the search box (one PubNub call
  // per channel per load instead of per keystroke); cleared whenever the channel list reloads.
  private memberCountCache = new Map<string, number>();

  async onTypeSearch(e: any, refreshCounts = false) {
    if (refreshCounts) this.memberCountCache.clear();
    const query = (typeof e === 'string' ? e : (e?.target as HTMLInputElement)?.value ?? this.searchQuery ?? '').toLowerCase();
    this.filteredPrivateChannels = this.privateChannels.map(team => ({
      ...team,
      expanded: true,
      channels: (team.channels || []).filter(channel => channel.channelName?.toLowerCase().includes(query))
    }));
    this.filteredPublicChannels = this.publicChannels.filter(channel => channel.channelName?.toLowerCase().includes(query));
    this.filteredJoinedChannels = this.joinedChannels.filter(channel => channel.channelName?.toLowerCase().includes(query));
    this.filteredStarredChannels = this.starredChannels.filter(channel => channel.channelName?.toLowerCase().includes(query));
    this.filteredTrendingChannels = this.trendingChannels.filter(channel => channel.channelName?.toLowerCase().includes(query));
    this.filteredTrendingChannels = await Promise.all(
      this.filteredTrendingChannels.map(async (channel) => {
        let count = this.memberCountCache.get(channel.channelUrl);
        if (count === undefined) {
          count = await this.pubnubService.getChannelMemberCount(channel.channelUrl);
          // 0/undefined is also what the service returns before the PubNub identity is ready
          // or on error, so only real counts are reused; anything else is re-fetched as before.
          if (count > 0) this.memberCountCache.set(channel.channelUrl, count);
        }
        return { ...channel, memberCount: count };
      })
    );
    this.cdRef.detectChanges();
  }


  matchesTab(channel: any): boolean {
    if (this.userRole !== "affiliate") return true;
    const visibility = (channel.channelVisibility || '').toLowerCase().trim();
    return this.activeTab === 'private' ? visibility === 'private' : visibility === 'public';
  }

  matchesSearch(channel: any): any {
    // console.log("matchesSearch", channel.channelName,channel.name);
    if (!this.searchQuery) return true;
    const name = channel.channelName || channel.name || '';
    return name.toLowerCase().includes(this.searchQuery.toLowerCase());
  }

  switchTab(tab: 'private' | 'public') {
    this.activeTab = tab;
  }


  getSectionChannels(section: string): any[] {
    const isAffiliate = this.userRole === "affiliate";
    const isAthlete = this.userRole === "athlete";
    const isPrivate = this.activeTab === 'private';
    const getBaseChannels = () => {
      switch (true) {
        case isAffiliate && isPrivate:
          return this.filteredPrivateChannels;
        case isAffiliate && !isPrivate:
          return this.filteredPublicChannels;
        case isAthlete && isPrivate:
          return this.filteredPrivateChannels;
        case isAthlete && !isPrivate:
          return this.filteredPublicChannels;
        default:
          return this.channels;
      }
    };
    
    const baseChannels = getBaseChannels();
    const filterBySearch = (list: any[]) =>
      list.filter(channel => this.matchesSearch(channel));

    switch (section) {

      case 'Channels':
        if (isPrivate) {
          return baseChannels.filter(team => {
            const matchingChannels = team.channels?.filter(channel =>
              (channel.channelVisibility || '').toLowerCase() === 'private' &&
              channel.users?.some(user => user.pubNubUserId === this.user_id)
            );
            if (matchingChannels && matchingChannels.length > 0) {
              team.channels = matchingChannels;
              return true;
            }

            return false;
          });
        }
        return [];

      case 'My Spaces':
        return filterBySearch(baseChannels).filter(channel =>
          this.searchQuery || (channel.createdBy?.split('_')[1] === this.userInfo.id)
        );
      case 'Starred':
        return filterBySearch(this.filteredStarredChannels).filter(channel =>
          this.searchQuery || ((channel.createdBy?.split('_')[1] !== this.userInfo.id)));

      case 'joined':
        // Starred and Joined are independent - a channel being starred
        // should not hide it from Joined (previously excluded anything in
        // filteredStarredChannels here, which silently hid a joined+starred
        // channel from this section entirely).
        return filterBySearch(this.filteredJoinedChannels).filter(channel =>
            (channel.createdBy?.split('_')[1] !== this.userInfo.id) &&
            this.joinedChannelNames.includes(channel.channelUrl)
        );
      
      case 'trending': {
        const trendingList = this.trendingChannelsData?.length > 0
          ? this.trendingChannelsData
          : [...this.filteredTrendingChannels].sort((a, b) => (b.memberCount || 0) - (a.memberCount || 0));
        return this.searchQuery
          ? trendingList.filter(ch => (ch.channelName || ch.name || '').toLowerCase().includes(this.searchQuery.toLowerCase()))
          : trendingList;
      }

      default:
        return [];
    }
  }

  toggleAccordion(section: string): void {
    this.accordion[section] = !this.accordion[section];
  }

  toggleTeamAccordion(team: any): void {
    team.expanded = !team.expanded;
  }
  connectChannels() {
    try {
      let pubnubUserId = 'fan_' + this.userInfo.id.toString();
      this.pubnubService.connect(pubnubUserId, async (success, error) => {
        if (error) return;
        this.channelIdsList = this.getAllChannelNames();
        const join = this.joinedChannels.map(channel => channel.channelUrl);
        await this.pubnubService.subscribeToChannels(join);
        this.pubnubService.initializeUnreadStatus(join);
      });
    } catch (e) {
      console.log(e);
      this.ngxLoader.stop();
    }
  }
  
  getAllChannelNames() {
    let channelUrls: string[] = [];
    if (this.userRole === 'affiliate') {
      if (this.activeTab === 'private') {
        // All accessible private channels grouped by teams
        const filteredPrivateTeamsList = this.privateChannels.map(team => ({
          ...team,
          channels: team.teamId
            ? team.channels.filter(channel => channel.users?.some(user => user.pubNubUserId === this.user_id))
            : team.channels
        }));
        const privateChannelUrls = filteredPrivateTeamsList
          .map(team => team.channels.map(channel => channel.channelUrl))
          .flat();
        channelUrls = privateChannelUrls;
      } else {
        const publicChannelUrls = this.publicChannels.map(channel => channel.channelUrl);
        const joinedChannelUrls = this.joinedChannels.map(channel => channel.channelUrl);
        const starredChannelUrls = this.starredChannels.map(channel => channel.channelUrl);
        channelUrls = [...publicChannelUrls, ...joinedChannelUrls, ...starredChannelUrls];
      }
    } else {
      // Non-affiliate: created + joined 
      const createdChannelUrls = this.channels.map(channel => channel.channelUrl);
      const joinedChannelUrls = this.joinedChannels.map(channel => channel.channelUrl);
      const starredChannelUrls = this.starredChannels.map(channel => channel.channelUrl);
      channelUrls = [...createdChannelUrls, ...joinedChannelUrls, ...starredChannelUrls];
    }
    return channelUrls;
  }

  addChannel(): void {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Add Space Clicked - ${userId}`)
    const payload = {
      actionType: "community",
      metaData: {
        title: `Add Space Clicked`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this?.organizationId || null,
      clickAction:'add-space'
    }
    this.commanService.sendTriggeredEvent(payload);
    const dialogRef = this.matDialog.open(AddChannelCommunityDialogComponent, {
      minWidth: '500px',
      maxWidth: '550px',
      data: { isAddChannel: true, settingsData: this.settingsData }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.createChannel(result);
      }
    });
  }

  createChannel(details: any) {
    const url = API.CREATE_UPDATE_COMMUNITY_CHANNEL;
    // const url=API.CREATE_ORG_COMMUNITY_CHANNEL;
    const isAffiliate = this.userRole === "affiliate";
    // this.organizationId = 28;
    const groupId = this.commanSubscribeService.activeGroupId;
    const data: any = {
      channelName: details.channel_name,
      description: details.description,
      organizationId: this.organizationId,
      dataStatus: "P",
      type: details.team ? "sub" : "main",
      createdByType: "fan",
      channelVisibility: isAffiliate ? this.activeTab : "public",
      createdByName: this.userInfo.user_display_name,
      // Without this, the creating fan is never persisted as a channel user
      // (community-service only auto-appends partners/performers here), so
      // they never get a PubNub membership record and get 403'd on their own
      // channel - both now and after partner approval, since approval relies
      // on previously-persisted users rather than resupplying channelUsers.
      channelUsers: [
        {
          userId: Number(this.userInfo.id),
          pubNubUserId: 'fan_' + this.userInfo.id,
          userType: 'fan',
          userInfo: { firstName: this.userInfo.user_display_name },
        },
      ],
      ...(details.team && { teamId: details.team.id, teamName: details.team.name }),
      ...(groupId && { networkGroupId: groupId })
    };

    this.appTVService.postBase1Request(url, data, 'fan_' + this.userInfo.id).subscribe({
      next: () => {
        // The new channel isn't covered by whatever PAM token is currently
        // cached - refresh it so the creator can access their own channel
        // as soon as it's actually live in PubNub (e.g. after approval),
        // instead of hitting a 403 on a stale token.
        this.pubnubService.refreshToken('fan_' + this.userInfo.id);
        this.getAllChannels();
      },
      error: (error) => {
      let message = 'Failed to create channel';
      if (error?.error?.includes('already existed')) {
        message = 'A channel with this name already exists';
      }
      this.toaster.error(message)
    }
    });
  }

  headBackToNetwork() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    //const albumId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`Head back to network is clicked - ${userId}`)
    const u_payload = {
        actionType: "network",
        metaData: {
          title: `Head back to network is clicked`,
          timeStamp: new Date().toISOString()
        },
        organizationId: this.organizationId || null,

        clickAction: `network`
    }
    this.commonSubscribeService.sendTriggeredEvent(u_payload);

    localStorage.removeItem('isJoinedChannel');
    this.router.navigate([this.commanSubscribeService.getChannelBasePath(this.channelName)]);
  }

  ngOnDestroy() {
    localStorage.removeItem('isJoinedChannel');
    this.pubnubService.disconnect(this.channelIdsList);
    if (this.joinedChannelsSub) {
      this.joinedChannelsSub.unsubscribe();
    }
    if (this.keysetReadySub) {
      this.keysetReadySub.unsubscribe();
    }
    this.trendingSocketSub?.unsubscribe();
    this.wsService.close();
  }

   navigateToCommunity(channelName: string,channelDetails: any): void {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Channel ${channelDetails.channelName} Clicked - ${userId}`)
    const payload = {
      actionType: "community",
      metaData: {
        title: `Channel ${channelDetails.channelName} Clicked`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.organizationId || null,

      clickAction:'channel-viewed'
    }
    this.commanSubscribeService.sendTriggeredEvent(payload);

    this.activeChannel = channelName;
    const starredChannels = this.getSectionChannels('Starred');
    const joinedChannels = this.getSectionChannels('joined');
    const joinedChannelUrls = this.joinedChannelNames;

    const isDirectlyJoined = joinedChannels.some(channel => channel.channelId === channelName);
    const isStarredAndJoinedByUrl = starredChannels
      .filter(channel => channel.channelId === channelName)
      .some(channel => joinedChannelUrls.includes(channel.channelUrl));
  
    const isJoined = (isDirectlyJoined || isStarredAndJoinedByUrl) ? 'true' : '';
    this.commanSubscribeService.sendSpaceDetails(channelDetails);
    // const isJoined = this.getSectionChannels('joined').some(channel => channel.channelId === channelName) ? 'true' : '';
    // const isStarred=this.getSectionChannels('Starred').some(channel => channel.channelId === channelName) ? 'true' : '';
   
    localStorage.setItem('isJoinedChannel', isJoined);
    this.router.navigate([this.commanSubscribeService.getChannelBasePath(this.channelName) + "/community/" + channelName]);
  }

  filterChannels() {
    const query = this.searchQuery.toLowerCase();
    console.log("query", query, this.filteredPrivateChannels, this.filteredPublicChannels);

    if (this.userRole === "affiliate") {
      if (this.activeTab === 'public') {
        this.filteredPublicChannels = this.publicChannels.filter(channel =>
          (channel.channelName || channel.name || '').toLowerCase().includes(query)
        );
      }
      else if (this.activeTab === 'private' && this.userRole === "affiliate") {
        this.filteredPrivateChannels = this.privateChannels
          .map(team => {
            const filteredTeamChannels = team.channels.filter(channel =>
              (channel.channelName || channel.name || '').toLowerCase().includes(query)
            );
          })
      }
    } else {
      this.filteredChannels = this.channels.filter(channel => (channel.channelName || channel.name || '').toLowerCase().includes(query));
    }

    this.filteredStarredChannels = this.starredChannels.filter(channel => (channel.name || '').toLowerCase().includes(query));
    this.filteredJoinedChannels = this.joinedChannels.filter(channel => (channel.name || '').toLowerCase().includes(query));
    this.filteredTrendingChannels = this.trendingChannels.filter(channel => (channel.channelName || channel.name || '').toLowerCase().includes(query));
  }
  getSectionIcon(section: string): string | null {

    switch (section) {
      case 'Starred':
        return 'assets/starred.png';
      case 'joined':
        return 'assets/joined.png';
      case 'trending':
        return 'assets/trending.png';
      default:
        return null;
    }
  }

  //Applying dynamic color for png icons
  // getIconFilter(): string {
  //   const color = this.settingsData.space_bg_primary_color?.toLowerCase() || '#000000';

  //   if (color === '#ffffff' || color === '#fff' || color ==='#e3e3e3') {
  //       return 'brightness(0.1) invert(0)'; 
  //   }
  // }
  getIconFilter(): string {
    const hex = this.settingsData?.space_bg_primary_color?.toLowerCase() || '#000000';
  
    const luminance = this.getLuminance(hex);
    if (luminance > 0.9) {
      return 'brightness(0.1) invert(0)';
    }
    return '';
  }

  CommunityChannelSearch() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Searching Channel" - ${userId}`);
    const data = {
      actionType: "community",
      metaData: {
        title: `Searching Channel`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this?.organizationId || null,

      clickAction:'search'
    }
    this.commanService.sendTriggeredEvent(data);
  }
  
  private getLuminance(hex: string): number {
    if (hex.length === 4) {
      hex = '#' + hex[1] + hex[1] + hex[2] + hex[2] + hex[3] + hex[3];
    }
  
    const r = parseInt(hex.slice(1, 3), 16) / 255;
    const g = parseInt(hex.slice(3, 5), 16) / 255;
    const b = parseInt(hex.slice(5, 7), 16) / 255;
    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
    return luminance;
  }

  addStyle() {
    if (this.settingsData?.font_family) {
      document.documentElement.style.setProperty('--app-font', this.settingsData.font_family);
    }
  }
}